/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnResponsibility.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnResponsibility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="EnResponsibility-view">
        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="EnResponsibility-first">
          <div className="EnResponsibility-firstContainer">
            <div className="EnResponsibility-firstHeading">
              Based in Hong Kong <br /> Stay with Hong Kong
            </div>

            <div className="EnResponsibility-firstsubHeading">
              CheckPlus actively works with many local organizations.
            </div>
          </div>
        </div>

        <div className="EnResponsibility-second">
          <div className="EnResponsibility-content">
            <div className="EnResponsibility-picture1" />
            <div className="EnResponsibility-description">
              Partner and share with various nonprofits
            </div>
            <div className="EnResponsibility-picture2" />
            <div className="EnResponsibility-description">
              Invited to attend various nonprofit events
            </div>
            <div className="EnResponsibility-picture3" />
            <div className="EnResponsibility-description">
              Mr. Edward Lai Kwan-Ho (Left) and Mr. Man Fai Yuen (Right)
            </div>
            <div className="EnResponsibility-picture4" />
            <div className="EnResponsibility-description">
              Mr. Ka-Po Yip (Left) and Mr. Edward Lai Kwan-Ho (Right)
            </div>
            <div className="EnResponsibility-picture5" />
            <div className="EnResponsibility-description">
              Mr. David Hui Chiu-ying (Left), <br />
              ￼Mr Edward Yau Tang-wah, GBS, JP, <br />
              Secretary for Commerce and Economic Development (Middle)
              <br />
              and Mr. Edward Lai Kwan-Ho (Right)
            </div>
          </div>
        </div>

        <div className="EnResponsibility-footer">
          <div className="EnResponsibility-footerNav">
            <Link to="/EnTeam">
              <div className="EnResponsibility-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnResponsibility-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnResponsibility-footerNavItem">Contact Us</div>
            </Link>
          </div>

          <div className="EnResponsibility-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnResponsibility;
